import { Link } from "react-router-dom"
import { PublicHeader, PublicFooter, PublicContact, usePublicLocale } from "../components/PublicLayout"

const LegalPage = () => {
  const { copy: { legal, common }, localize } = usePublicLocale()
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-orange-50">
      <PublicHeader />
      <main className="public-document">
        <div className="public-document-lead">
          <p className="public-eyebrow">{legal.eyebrow}</p>
          <h1>{legal.title}</h1>
          <p>{legal.description}</p>
        </div>
        <section className="public-card public-notice">
          <h2>{legal.warningsTitle}</h2>
          <ul>{legal.warnings.map((warning) => <li key={warning}>{warning}</li>)}</ul>
        </section>
        {legal.sections.map(({ title, paragraphs }) => (
          <section className="public-card" key={title}>
            <h2>{title}</h2>
            {paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
          </section>
        ))}
        <Link to={localize("/legal/privacy-policy")}>{common.privacyLink}</Link>
        <PublicContact title={legal.contactTitle} description={legal.contactDescription} />
      </main>
      <PublicFooter />
    </div>
  )
}

export default LegalPage
